/* MIT License
 *
 * Copyright (c) 2023 Mike Chambers
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */

import { Buffer } from "buffer";

export const parseWeaponsFromServer = (weapons, manifest) => {
    let out = [];
    for (const w of weapons) {
        let item = manifest.getWeaponDefinition(w.id);
        w.item = item;
        out.push(w);
    }
    return out;
};

export const parseMedalsFromServer = (medals, manifest) => {
    let out = [];
    for (const m of medals) {
        let info = manifest.getMedalDefinition(m.id);
        m.info = info;
        out.push(m);
    }
    return out;
};

export const reducer = (initial, type, payload) => {
    let out = { ...initial };
    out[type] = payload;
    return out;
};

export const serialize = function (data) {
    let json = JSON.stringify(data);
    let encoded = Buffer.from(json).toString("base64");

    return encoded;
};

export const deserialize = function (encoded) {
    let json = Buffer.from(encoded, "base64").toString("utf8");

    let data = JSON.parse(json);

    return data;
};
